/**
 * Contact — hello, choose a mission, send the message. The server writes
 * the page (templates/site/contact.html.twig); this moves it.
 *
 * @module pages/contact
 */

import { $ } from '../lib/dom.js';
import * as messageConsole from '../sections/contact/console.js';
import * as missions from '../sections/contact/missions.js';
import * as opening from '../sections/contact/opening.js';

export function animate() {
    opening.animate($('#hello'));
    missions.animate();
    messageConsole.animate();
}
